"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { classNames, responsiveClassNames, responsivePropDependency } from "../../utilities/props.js";
import useIsomorphicLayoutEffect from "../../hooks/useIsomorphicLayoutEffect.js";
import HiddenInput from "../_private/HiddenInput/index.js";
import { useFormControl } from "../FormControl/index.js";
import { useCheckboxGroup } from "../CheckboxGroup/index.js";
import Icon from "../Icon/index.js";
import Text from "../Text/index.js";
import IconCheckmark from "../../icons/Checkmark.js";
import s from "./Checkbox.module.css";
const Checkbox = (props) => {
    const { children, value, onChange, onFocus, onBlur, indeterminate, size = "medium", className, attributes, inputAttributes, } = props;
    const checkboxGroup = useCheckboxGroup();
    const formControl = useFormControl();
    const hasError = formControl?.hasError || props.hasError || checkboxGroup?.hasError;
    const disabled = formControl?.disabled || props.disabled || checkboxGroup?.disabled;
    const checked = checkboxGroup ? checkboxGroup.value?.includes(value) : props.checked;
    const defaultChecked = checkboxGroup ? undefined : props.defaultChecked;
    const name = checkboxGroup ? checkboxGroup.name : props.name;
    const inputRef = React.useRef(null);
    const rootClassName = classNames(s.root, className, size && hasError && s["--error"], disabled && s["--disabled"], size && responsiveClassNames(s, "--size", size));
    const handleChange = (event) => {
        if (!name)
            return;
        const { checked } = event.target;
        const changeArgs = { name, value, checked, event };
        if (onChange)
            onChange(changeArgs);
        if (checkboxGroup?.onChange)
            checkboxGroup.onChange(changeArgs);
    };
    useIsomorphicLayoutEffect(() => {
        inputRef.current.indeterminate = indeterminate || false;
    }, [indeterminate, checked]);
    return (_jsxs("label", { ...attributes, className: rootClassName, children: [_jsxs("span", { className: s.field, children: [_jsx(HiddenInput, { className: s.input, type: "checkbox", checked: checked, defaultChecked: defaultChecked, name: name, disabled: disabled, value: value, onChange: handleChange, onFocus: onFocus, onBlur: onBlur, attributes: {
                            ...inputAttributes,
                            ref: inputRef,
                        } }), _jsx("div", { className: s.decorator, children: _jsx(Icon, { svg: IconCheckmark, className: s.icon, size: responsivePropDependency(size, (size) => {
                                if (size === "large")
                                    return 5;
                                if (size === "small")
                                    return 3;
                                return 4;
                            }) }) })] }), children && (_jsx(Text, { as: "span", variant: responsivePropDependency(size, (size) => {
                    if (size === "large")
                        return "body-2";
                    if (size === "small")
                        return "caption-1";
                    return "body-3";
                }), children: children }))] }));
};
Checkbox.displayName = "Checkbox";
export default Checkbox;
